import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

export default function CurateRedirect() {
  const { user } = useAuth();

  // Unauthenticated users are sent home — they can't browse their own or saved collections.
  // The explore / canonical-list page will be the discovery entry point after its refactor.
  if (!user) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/curate/u/${user.username}`} replace />;
}
